import { PropType, defineComponent } from "vue";
import { KahiListItemData } from "@/@types";
import KahiMetaInfo from "@/components/KahiMetaInfo/KahiMetaInfo.vue";
import KahiPhoto from "@/components/KahiPhoto/KahiPhoto.vue";
import { breakLineUta, convertDistance } from "@/filters";

export default defineComponent({
  name: "KahiSummary",
  components: {
    KahiMetaInfo,
    KahiPhoto
  },
  props: {
    imageLoad: {
      type: Boolean,
      required: true
    },
    kahi: {
      type: Object as PropType<KahiListItemData>,
      required: true
    }
  },
  setup() {
    return {
      breakLineUta,
      convertDistance
    };
  }
});
